import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { WowImage, ImageResizeOptions } from '..';
import { classes } from './WowImage.visual.st.css';

function renderImage(stretch) {
  return (
    <div
      style={{
        width: 200,
        height: 100,
        background: 'lightgrey',
      }}
    >
      <WowImage
        stretchImage={stretch}
        sourceWidth={66}
        sourceHeight={63}
        src="f77a29_e163ea53eab341b48c4edd7049f290f1~mv2.jpg"
        fluid
        resize={ImageResizeOptions.contain}
      />
    </div>
  );
}

storiesOf('WowImage', module)
  .add('true', () => renderImage(true))
  .add('false', () => renderImage(false))
  .add('forceImageContain', () => {
    const renderContainImage = (
      aspectRatio,
      { width, height },
      backgroundColor,
    ) => (
      <div
        style={{
          width,
          height,
          backgroundColor,
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          position: 'relative',
        }}
      >
        <WowImage
          src="f77a29_e163ea53eab341b48c4edd7049f290f1~mv2.jpg"
          sourceHeight={2000}
          sourceWidth={2000}
          resize={ImageResizeOptions.contain}
          className={classes.borderRadius}
          forceImageContain
          containerAspectRatio={aspectRatio}
          fluid
          stretchImage={false}
        />
      </div>
    );

    return (
      <div
        style={{
          display: 'flex',
          gap: 30,
        }}
      >
        {renderContainImage(16 / 9, { width: 160, height: 90 }, 'black')}
        {renderContainImage(9 / 16, { width: 90, height: 160 }, 'blue')}
        {renderContainImage(1, { width: 100, height: 100 }, 'green')}
      </div>
    );
  });
